export default __webpack_public_path__ + "static/media/Principal4 - Copy.f1b52f58.jpeg";